const all = {
  all: "全部",
  point_channel: "积分收集渠道",
  member_tier: "会员级别",
  point_remain: "剩余积分",
  total_spend: "累计金额",
  more_spending: "累积额外金额",
  marketplace_channel: "连接通道",
  status: "地位",
  connect_status: "连接完成",
  connect_status_error: "",
  btn_connect_market: "添加连接通道",
  btn_disconnect_market: "删除连接",
  btn_connect: "关联",
  point: "分数",
  current_point: "目前累积积分",
  redeem_quantity: "交换的产品数量",
  point_used: "使用点数",
  expired: "到期",
  expired_date: "截止日期",
  member_expired_date: "会员资格有效期",
  point_total: "您的累积积分",
  currency_unit: "铢",
  note: "笔记",
  note_market: "用于连接各种通道",
  note_market_1: "第一个通道连接",
  note_market_2: "下次",
  history: "使用历史",
  see_detail: "查看详情",
  description: "细节",
  redeem_date: "最多可兑换",
  use: "使用",
  profile_general: "一般信息",
  profile_address: "地址信息",
  profile_additional: "附加信息",
  policy: "个人资料保护政策",
  pdpa: "管理个人信息",
  term: "条款和条件",
  billing: "税务发票地址",
  shipping: "收件地址",
  contact: "联络人",
  add_billing: "添加税务发票地址",
  add_shipping: "添加送货地址",
  add_contact: "添加联系人",
  info_billing: "税务发票地址信息",
  info_shipping: "送货地址信息",
  info_contact: "联系信息",
  use_as_profile: "使用私人地址",
  add: "增加",
  ext: "继续",
  default: "默认",
  save: "记录",
  confirm: "确认",
  branch_select_coupon: "选择使用优惠券的分行。",
  confirm_used: "确认使用",
  cancel: "取消",
  close_window: "关闭此窗口",
  mission_detail: "任务详情",
  mission_reward: "礼品套装",
  get_reward: "获得奖励",
  spending: "累计购买金额",
  finish: "结束",
  process: "进行中",
  privilege_receive_success: "成功确认收到权利",
  privilege_code: "特殊特权代码",
  placeholder: "请填写",
  use_coupon: "按使用优惠券",
  coupon_code: "优惠券代码",
  coupon_note: "该优惠券如果按下确认，将立即使用。\n",
  point_receive_total: "收到/使用的积分数量",
  your_point: "你的分数",
  list: "列表",
  profile: "个人信息",
  privilege: "好处",
  logout: "退出",
  member_tier_expired: "会员级别将在以下时间内到期",
  to_upgrade: "升级",
  maintain: "维持分数水平",
  next_tier: "下一个订单",
  keep_current: "获得状态",
  qr_count_time: "QR 码 此代码将在以下时间内过期",
  total_spend_unit: "累计金额（泰铢）",
  count_purchase_times: "购买产品（次）",
  count_purchase_unit: "购买产品（泰铢）",
  collect_point: "累积积分",
  back: "返回首页",
  need_point: "想要更多积分",
  complate_profile: "信息的完整性",
  edit_profile: "编辑个人信息",
  edit: "正确的",
  firstname: "姓名",
  lastname: "姓",
  email: "电子邮件",
  telephone: "电话号码",
  birthday: "生日",
  point_expired: "即将过期的积分"
};

const input = {
  purchase_channel: "订购渠道",
  market_name: "店铺名称",
  order_no: "订单号（订单号）",
  track_id: "运输编号（追踪 ID）"
};
const cn = { ...input, ...all };
export default cn;
